import React, { useEffect, useState } from 'react'
import SideBarLayout from '../layouts/SideBarLayout'
import Modal from '../components/Modal'
import BowtieDiagram from '../components/diagram/BowtieDiagram'
import Loader from '../components/loaders/Loader'
import { useLocation, useNavigate } from 'react-router-dom'
import instance from '../api/client'
import authService from '../authentication'
import { toast } from 'react-toastify'
import { nodes as initialNodes, edges as initialEdges, edges } from '../components/diagram/initial-elements';
import PrioritizationUI from '../components/diagram/PrioritizationUI'

export default function PrioritizationInterface({ }) {
  const [loading, setLoading] = useState(false)
  const { state } = useLocation();
  const navigate = useNavigate();
  const [edges, setEdges] = useState([]);
  const [nodes, setNodes] = useState([]);

  useEffect(() => {
    getImpacts()
  }, [])

  console.log(state)

  const getImpacts = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.get(`/prioritize/get-all-impacts/${state.project.code}`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        console.log('All impacts:', data)
        const diagrams = new Set(data.map((n) => n.diagramName))
        const positionMap = {}
        diagrams.forEach((d) => {
          positionMap[d] = data.filter((n) => d == n.diagramName)
        })
        const diagramHeaders = []
        let k = 0
        for (let d in positionMap) {
          diagramHeaders.push({
            id: d, type: 'diagramHeader', draggable: false, colorNumber: k, position: { x: 0 + (250 * k), y: 50 }
          })
          for (let index = 0; index < positionMap[d].length; index++) {
            let n = positionMap[d][index]
            n.position = { x: 0 + (250 * k), y: 200 + (200 * index) }
            n.id = `${d} ${index}`
            n.draggable = false
            n.colorNumber = k
            n.type = 'staticImpact'
          }
          k++;
        }

        setNodes([...diagramHeaders, ...data])
        setLoading(false)
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  return (
    <>
      {loading ?
        <div className='absolute z-50 flex w-full h-full items-center justify-center bg-modal'>
          <div className=' flex items-center justify-center'>
            <Loader animationName={'collab'} height={300} width={400} />
          </div>
        </div>
        :
        <div className='w-full h-[100vh] bg-gray-800'>
          <PrioritizationUI state={state} getImpacts={getImpacts} initialNodes={nodes} initialEdges={edges} />
        </div>
      }
    </>
  )
}
